exports.serviceTeam="hanwha";
exports.serviceType="analyzer";
exports.authServerHost = `${process.env.REACT_APP_AUTH_API_URL}`;